/// <amd-module name="TFS/Msal/TfsMsalInteractiveService.types" />

import { IVssService } from "VSS/Platform/Context";

export interface ITfsMsalInteractiveService extends IVssService {
    signOut(queryParameters?: URLSearchParams): Promise<void>;
}
